
export function getStoreFromUrl(url) {
  try {
    const u = new URL(url);
    return u.searchParams.get("0_store");
  } catch (e) {
    console.error("Invalid URL passed to getStoreFromUrl:", url);
    return null;
  }
}

const STORE_NAMES_FF = {
  "60a8e2ef88386f4c0c75a58a": "Al Farooj Fresh - Abu Hail Dubai", // +
  //"60a8edb84fa7cd28f240661e": "Al Farooj Fresh - Warehouse", // to disable
  //"60a8eeb341bb70768c66ee3c": "Al Farooj Fresh - Central Kitchen", // to disable
  "60d824097c85f717826beddc":"Al Farooj Fresh - Al Barsha Mall Dubai", //+
  "60d824a78c164f16d826d169":"Al Farooj Fresh - King Faisal Sharjah", // +
  "60dafa4e7705a663ef4f5268":"Al Farooj Fresh - Manaseer Al Ain", // +
  "60db06852498467f361de7c7":"Al Farooj Fresh - Tawam Al Ain", // +
  "60e5d82a66b5e63019240702": "AL Farooj Fresh - Mirdiff Way Food Truck", //+
  
  //"6145986916e3af4b7e7a5785":"Al Farooj Fresh - LIWA", //to disable
  //"619e1f0f19ee3b40ed5119a8":"Al Farooj Fresh - Catering ( Al Wasl Club )", //to disable
  "61a33bf4733ee01e5033a796":"Al Farooj Fresh - Ajman", // ok
  //"6204d056fa0f3b04ce24cb3a":"Al Farooj Fresh - Kiosk", // to disable
  "668fa2f13dcf74671f035983":"Al Farooj Fresh - Al Hilli Al Ain", // +
  "675829dd094af474350308b4":"Al Farooj Fresh - Ajman Food Truck", // +
};
export default STORE_NAMES_FF;
// utils/getStoreFromUrl.js

//688b8cbab2056ab08208c7b1